import React from "react";
import { motion } from "framer-motion";
import { FaUsers, FaCogs, FaCloud } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const UniqueApproach = () => {
  const { t } = useLanguage();

  const items = [
    {
      title: t("uniqueApproach.people.title"),
      quote: t("uniqueApproach.people.quote"),
      source: t("uniqueApproach.people.source"),
      icon: <FaUsers />,
    },
    {
      title: t("uniqueApproach.process.title"),
      quote: t("uniqueApproach.process.quote"),
      source: t("uniqueApproach.process.source"),
      icon: <FaCogs />,
    },
    {
      title: t("uniqueApproach.technology.title"),
      quote: t("uniqueApproach.technology.quote"),
      source: t("uniqueApproach.technology.source"),
      icon: <FaCloud />,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="bg-blue-50 text-gray-900 py-24 text-center"
    >
      <h2 className="text-5xl font-bold text-yellow-600">{t("uniqueApproach.title")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-12 mt-12">
        {items.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            whileHover={{ scale: 1.07, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)" }}
            className="border border-gray-300 rounded-xl p-6 shadow-lg bg-gradient-to-br from-gray-100 to-white transition-all duration-300 flex flex-col items-center justify-center min-h-72"
          >
            <motion.div
              whileHover={{ scale: 1.1 }}
              animate={{ y: [0, -5, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
              className="text-5xl text-yellow-600"
            >
              {item.icon}
            </motion.div>

            <h3 className="text-3xl font-bold text-yellow-600 mt-4">{item.title}</h3>
            <p className="text-base text-gray-700 mt-2">{item.quote}</p>
            <p className="text-sm text-gray-500 mt-2 italic">{item.source}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default UniqueApproach;
